/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_CodeInputs */

const en_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your code:`)
};

const es_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu código:`)
};

const fr_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre code :`)
};

const de_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Code:`)
};

const ja_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのコード:`)
};

const zh_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的推荐码：`)
};

const ar_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمزك:`)
};

const id_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode Anda:`)
};

const it_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo codice:`)
};

const ru_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш код:`)
};

const pt_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu código:`)
};

const ko_your_code = /** @type {(inputs: Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 코드:`)
};

/**
* | output |
* | --- |
* | "Your code:" |
*
* @param {Your_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_code = /** @type {((inputs?: Your_CodeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_CodeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_code(inputs)
	if (locale === "es") return es_your_code(inputs)
	if (locale === "fr") return fr_your_code(inputs)
	if (locale === "de") return de_your_code(inputs)
	if (locale === "ja") return ja_your_code(inputs)
	if (locale === "zh") return zh_your_code(inputs)
	if (locale === "ar") return ar_your_code(inputs)
	if (locale === "id") return id_your_code(inputs)
	if (locale === "it") return it_your_code(inputs)
	if (locale === "ru") return ru_your_code(inputs)
	if (locale === "pt") return pt_your_code(inputs)
	return ko_your_code(inputs)
});